import { toast } from "react-toastify";

const initState = {
  loading: false,
  submitting: false,
  uploaded: null,
  trashfilesid: null,
};

const airtimeReducer = (state = initState, action) => {
  switch (action.type) {
    case "BUY_AIR_TIME":
      toast.success("Airtime Purchase Complete!");
      window.location = "/";
      return {
        ...state,
        submitting: false,
      };

    case "BUY_AIR_TIME_ERROR":
      switch (action.payload.toString()) {
        case "Error: Insufficent Funds":
          toast.error(action.payload.toString());
          break;
        case "Error: Airtime Purchase is Temporarily Blocked!":
          toast.error(action.payload.toString());
          break;
        default:
          toast.error("Couldn't Purchase Airtime, Please Try Again");
          console.log(action.payload.toString());
          break;
      }
      return {
        ...state,
        submitting: false,
      };
    case "UPLOAD_AD_AUDIO":
      return {
        ...state,
        uploaded: action.payload.uploaded,
        trashfilesid: action.payload.trashfilesid,
        loading: false,
      };
    case "CLEAR_AD_AUDIO":
      return {
        ...state,
        uploaded: null,
      };
    case "UPLOAD_AD_AUDIO_ERROR":
      toast.error("Couldn't Upload your Audio File");
      console.log(action.payload);
      window.location = "/business_buy_airtime";
      return {
        ...state,
        loading: false,
        uploaded: null,
        trashfilesid: null,
      };
    case "LOADING_BUY_AIR_TIME":
      return {
        ...state,
        loading: true,
      };
    case "SUBMITTING_BUY_AIR_TIME":
      return {
        ...state,
        submitting: true,
      };
    default:
      return state;
  }
};

export default airtimeReducer;
